<template>
  <div class="page-contain">
    <div class="page-top">
      <div
        v-for="(item,index) in orderTabList"
        :key="item"
        class="order-tab"
        :class="index == orderType ?'tab-selected':''"
        @click="tabClick(index)"
      >{{ item }}</div>
    </div>
    <van-list
      v-model="loading"
      class="order-contain"
      :finished="finished"
      finished-text="没有更多了"
      @load="getOrderListRule">
      <van-cell
        v-for="(item,index) in orderList"
        :key="index"
      >
        <div
          class="order-item"
          @click="checkOrderDetail(item)"
        >
          <div class="order-item-top">
            <div class="order-num">订单号:<span class="gray-font">{{ item.out_trade_no }}</span></div>
            <div
              :class="['order-status', item.trade_state == 1 || item.trade_state == 3 || item.trade_state == 4 ? 'orange-font' : '', item.trade_state == 0 ? 'yellow-font' : '']"
            >{{ item.trade_state | statusFilter }}</div>
          </div>
          <div class="order-item-center">
            <img class="order-product-pic" :src="item.assemble_product_cover && item.assemble_product_cover.small_cover" />
            <div class="order-product-info">
              <div class="product-title">{{ getOrderItemTitle(item) }}</div>
              <div class="product-info">
                <div class="order-price">{{item.total_fee | priceFilter }}</div>
              </div>
              <div class="order-btn-line">
                <div
                  v-if="item.trade_state == 2"
                  class="orange-btn"
                  @click.stop="reBuy(item)"
                >重新下单</div>
                <div
                  v-if="item.trade_state == 0"
                  class="orange-btn gray-btn"
                  @click.stop="startCancelOrder(item)"
                >取消订单</div>
                <div
                  v-if="item.trade_state == 0"
                  class="orange-btn"
                  @click.stop="checkOrderDetail(item)"
                >付款</div>
                <div
                  v-if="[1,3,4].indexOf(item.trade_state) > -1"
                  class="orange-btn"
                  @click.stop="checkLogistical"
                >查看物流</div>
                <div
                  v-if="[1,3,4].indexOf(item.trade_state) > -1"
                  class="orange-btn"
                  @click.stop="intoGroup(item)"
                >入群学习</div>
              </div>
            </div>
          </div>
        </div>
      </van-cell>
    </van-list>
    <Dialog
      ref="orderDialog"
      :type="1"
      @confirm="checkOrderDetail({out_trade_no: cancelOrderInfo.out_trade_no})"
      @cancel="cancelOrder"
    />
  </div>
</template>
<script>
import OrderApi from 'api/OrderApi';
import Dialog from '@/components/Dialog';
import store from '../store/index';

export default {
  components: {
    Dialog
  },
  data() {
    return {
      orderTabList: ['全部订单', '待支付', '交易成功', '交易失败'],
      orderType: 0,
      orderList: [],
      loading: false,
      finished: false,
      downing: false,
      cancelOrderInfo: {},
    };
  },
  created() {
    this.getOrderList();
  },
  methods: {
    getOrderItemTitle(item) {
      if (!item) {
        return '';
      }

      if (!item.sub_orders || item.sub_orders.length < 2) {
        return item.assemble_product_title || '';
      }

      return item.sub_orders.map(o => o.title).join('+');
    },
    // 获取订单列表
    getOrderList(type) {
      let length = this.orderList.length
      const obj = {
        start_index: (this.orderList.length > 0 && type != "change") ? this.orderList[length - 1].gid : 0,
        ordering: "desc",
        platform: 1
      }
      this.orderType === 0 ? '' : obj.status = this.orderType - 1
      OrderApi.getOrder(obj).then(res => {
        this.loading = false
        this.downing = false
        if (type === "more") {
          this.orderList = [...this.orderList, ...res.data.items]
        } else {
          this.orderList = res.data.items || []
        }
        length = this.orderList.length
        if (length % 10 != 0 || length == 0) {
          this.finished = true
        } else {
          this.finished = false
        }
      })
    },
    // 查看订单详情
    checkOrderDetail({ out_trade_no }) {
      this.$router.push({
        name: 'orderDetail',
        query: {
          out_trade_no
        }
      });
    },
    // 取消订单
    cancelOrder() {
      OrderApi.deleteOrder({
        out_trade_no: this.cancelOrderInfo.out_trade_no
      }).then(res => {
        this.$toast("取消订单成功")
        this.getOrderList("change")
        this.$refs.orderDialog.hide()
      })
    },
    startCancelOrder(item) {
      this.cancelOrderInfo = item
      this.$refs.orderDialog.show()
    },
    // 重新购买
    reBuy({ assemble_product_id }) {
      this.$router.push({
        name: 'home',
        query: {
          productId: assemble_product_id
        }
      });
    },
    // 查看物流详情
    checkLogistical() {
      if (location.href.includes("xcx.hexiaoxiang")) {
        location.href = `https://yw.hexiaoxiang.com/statich5/art/logistics.html?key=${store.state.key}&logistics_source=8#/index`
      } else {
        location.href = `https://consoletest.hexiaoxiang.com/statich5/art/logistics.html?key=${store.state.key}&logistics_source=8#/index`
      }
    },
    // 切换订单类型
    tabClick(index) {
      this.orderType = index
      this.getOrderList("change")
    },
    intoGroup({ assemble_product_id }) {
      this.$router.push({
        name: 'paySuc',
        query: {
          productId: assemble_product_id
        }
      });
    },
    getOrderListRule() {
      if (this.downing) {
        return
      }
      this.downing = true
      this.getOrderList("more")
    }
  },
  filters: {
    statusFilter(val) {
      const arr = ['待付款', '交易完成', '交易关闭', '交易完成', '交易完成']
      return arr[val]
    },
    priceFilter(val) {
      return val ? "￥" + (val / 100) : ''
    }
  }
}
</script>
<style lang="scss" scoped>
.page-contain {
  width: 100%;
  .page-top {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 0 20px;
    height: 64px;
    box-sizing: border-box;
    .tab-selected {
      color: rgba(255, 255, 255, 1) !important;
      background: linear-gradient(
        90deg,
        rgba(254, 185, 107, 1) 0%,
        rgba(255, 109, 120, 1) 100%
      ) !important;
      box-shadow: 0 0 7px 0 rgba(254, 105, 63, 0.1) !important;
    }
    .order-tab {
      border-radius: 3px;
      box-shadow: 0 0 7px 0 rgba(30, 30, 37, 0.1);
      width: 71px;
      height: 31px;
      line-height: 31px;
      background: rgba(255, 255, 255, 1);
      font-size: 13px;
      text-align: center;
    }
  }
  .order-item {
    box-sizing: border-box;
    padding: 16px 20px 10px;
    width: 100%;
    .order-item-top {
      display: flex;
      justify-content: space-between;
      align-items: center;
      width: 100%;
      .order-num {
        height: 20px;
        line-height: 20px;
        font-size: 14px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: rgba(45, 46, 63, 1);
        .gray-font {
          margin-left: 4px;
          font-size: 12px;
          color: #8a8e99;
        }
      }
      .order-status {
        font-size: 13px;
      }
    }
    .order-item-center {
      display: flex;
      margin: 16px 0 10px;
      border-bottom: 1px solid #f0f0f5;
      padding-bottom: 16px;
      width: 100%;
      .order-product-pic {
        border-radius: 8px;
        width: 88px;
        height: 88px;
      }
      .order-product-info {
        margin-left: 16px;
        width: 230px;
        .product-title {
          margin-bottom: 10px;
          line-height: 22px;
          font-size: 15px;
          font-family: PingFangSC-Medium, PingFang SC;
          font-weight: 500;
          color: rgba(45, 46, 63, 1);
        }
        .product-sub-title {
          line-height: 18px;
          font-size: 13px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(138, 142, 153, 1);
        }
        .product-info {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          width: 100%;
          line-height: 18px;
          font-size: 12px;
          font-family: PingFangSC-Regular, PingFang SC;
          font-weight: 400;
          color: rgba(138, 142, 153, 1);
          .order-price {
            line-height: 28px;
            font-size: 20px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            color: rgba(254, 105, 63, 1);
          }
        }
        .order-btn-line {
          display: flex;
          justify-content: flex-end;
          align-items: center;
          height: 45px;
          .orange-btn {
            margin-left: 16px;
            border-radius: 4px;
            border: 1px solid rgba(254, 105, 63, 1);
            width: 80px;
            height: 32px;
            line-height: 32px;
            background: rgba(255, 255, 255, 1);
            font-size: 14px;
            font-family: PingFangSC-Regular, PingFang SC;
            font-weight: 400;
            color: rgba(254, 105, 63, 1);
            text-align: center;
          }
          .gray-btn {
            border: 1px solid #8a8e99;
            color: #8a8e99;
          }
        }
      }
    }
  }
}
</style>